var map = {
	"./cooperation1.jpg": 2335,
	"./cooperation2.jpg": 3423,
	"./cooperation3.jpg": 7339,
	"./cooperation4.jpg": 659,
	"./cooperation5.jpg": 4319,
	"./cooperation6.jpg": 1496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4230;